<template>
  <div>
    <table
      class="table table-head-custom table-head-bg table-borderless table-vertical-center"
    >
      <thead>
        <tr>
          <th>عنوان</th>
          <th>توضیحات</th>
          <th>عملیات</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(item, i) in list" :key="i">
          <td>{{ item.title }}</td>
          <td>{{ item.description }}</td>
          <td>
            <button
              type="button"
              class="btn btn-xs btn-primary mr-1"
              @click="sendTicket(item)"
            >
              ثبت تیکت
            </button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import { STORE_TICKET } from "@/core/services/store/tickets.module";

export default {
  name: "DropdownPrices",
  data() {
    return {
      isCompany: this.$route.name.startsWith("company"),
      isAdmin: this.$route.name.startsWith("admin"),
      list: [
        {
          id: "1",
          title: "اموزش و مشاوره پخش زنده",
          description: ""
        },
        {
          id: "2",
          title: "راه اندازی سیستم پخش زنده",
          description: ""
        },
        {
          id: "3",
          title: "پشتیبانی اختصاصی",
          description: ""
        },
        {
          id: "4",
          title: "سرور اختصاصی پخش زنده",
          description: ""
        }
      ],
      form: {
        title: "",
        priority: 1,
        message: ""
      }
    };
  },
  methods: {
    sendTicket(item) {
      this.$store
        .dispatch(STORE_TICKET, {
          user: this.isCompany || this.isAdmin ? this.$route.params.id : null,
          title: item.title,
          priority: parseInt(this.form.priority)
        })
        .then(ticket => {
          this.$router.push({
            name: "tickets-show",
            params: { id: ticket.id }
          });
        })
        .catch(() => {});
    }
  }
};
</script>
<style>
.accordion-button:hover {
  color: #000000 !important;
}
.accordion-button:active {
  color: #000000 !important;
}
</style>
